module.exports = __webpack_public_path__ + "img/5.67c35100.svg";